// @flow
// https://stackoverflow.com/questions/15125920/how-to-get-distinct-values-from-an-array-of-objects-in-javascript

export const uniqueBy = (arr: Array<any>, key: string): Array<any> => [
  ...new Map(arr.map((item) => [item[key], item])).values(),
];
